import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import FormControl from '../FormControl/FormControl.js';
import { isTextWithApostrophe } from '../Util/validations.js';

const City = (_param)=> {
    var { label , errorMessage , validations =[
        isTextWithApostrophe
    ]  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "label",
        "errorMessage",
        "validations"
    ]);
    return React.createElement(FormControl, swcHelpers.extends({}, FormControl.defaultProps, {
        id: "city",
        "data-t": "city",
        type: "text",
        label: label,
        errorMessage: errorMessage,
        validations: validations
    }, rest));
};
var City$1 = City;

export { City$1 as default };
//# sourceMappingURL=City.js.map
